module.exports = __webpack_public_path__ + "static/img/select_difficulty_photo.651897d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ai_training/select_difficulty_photo.png
// module id = U6kq
// module chunks = 1